import React from "react";
import { Grid, Paper } from "@mui/material";
import { ICompanions } from '../../models/registrationModels';
import RsDataField from "./RsDataField";
import GridItemContainer from "../layout/GridItemContainer";

const RsFellowTravelers = ({ companions }: { companions: ICompanions[] }) => {
  
  return (
    <Paper elevation={2} sx={{overflow:"hidden"}}>
      <Grid container>
          <GridItemContainer border isHeader xs={12}>
            <RsDataField labelStrong="MITREISENDE" labelSmall="im familiären Verbund (fellow travelers)" isHeader />
          </GridItemContainer>
        {companions.map((companion) => (
          <React.Fragment key={companion.id}>
            <GridItemContainer border xs={6} md={3}>
              <RsDataField labelStrong="FAMILIENNAME" labelSmall="(last name)" value={companion.name} />
            </GridItemContainer>
            <GridItemContainer border xs={6} md={3}>
              <RsDataField labelStrong="VORNAME" labelSmall="(first name)" value={companion.prename} />
            </GridItemContainer>
            <GridItemContainer border xs={6} md={3}>
              <RsDataField labelStrong="STAAT" labelSmall="(country)" value={companion.state} />
            </GridItemContainer>
            <GridItemContainer border xs={6} md={3}>
              <RsDataField labelStrong="GEB. DATUM" labelSmall="(date of birth)" value={companion.birthDate.toFormattedDateOrDefault()} />
            </GridItemContainer>
          </React.Fragment>
        ))}
      </Grid >
    </Paper>
  );
};

export default RsFellowTravelers;
